module.exports = __webpack_public_path__ + "static/16-01c71eb02bec13f0c6f34352d5ae0f0c.jpg";